import styled from "styled-components";

export const Wrapper = styled.div`

  button {
    all: unset;
  }
`

export const WrapperTooltipContent = styled.div`
`